// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__2iLxg","info":"PatientInfo_info__2LB4D"};